import httpClient from './httpClient';

export const ACCORDION_KEY_ENDPOINT = '/backoffice/product-accordion-keys';

export const getAccordionKeysAPI = async (params) => httpClient.get(`${ACCORDION_KEY_ENDPOINT}`, { params });
export const getAccordionKeyAPI = async (accordionKeyId) => httpClient.get(`${ACCORDION_KEY_ENDPOINT}/${accordionKeyId}`);
export const createAccordionKeyAPI = async (params) => httpClient.post(`${ACCORDION_KEY_ENDPOINT}`, params);
export const putAccordionKeyAPI = async (accordionKeyId, params) => httpClient.put(`${ACCORDION_KEY_ENDPOINT}/${accordionKeyId}`, params);
export const deleteAccordionKeyAPI = async (accordionKeyId) => httpClient.delete(`${ACCORDION_KEY_ENDPOINT}/${accordionKeyId}`);
